<template>
<w-sliding-popup type="setting" ref="slidingPopup" :title="selectTitle" :default-content="false" width="550px" @close="closePopup">
  <div slot="content" style="height:100%;">
    <el-form class="body-content-no-scroll" style="height:100%;" :model="controlInfo" label-position="top" ref="exceptInfoForm">
      <div class="mr-b25" style="height: calc(100% - 116px);">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="title-h4">포트 목록</div>
          <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </el-row>
        <el-table-wrapper style="height:calc(100% - 28px);" :fit-height="true" ref="portControlTable" :data="dataList" :columns="fileDetectColumns" :column-default="columnDefault"
         remote pagination :total="total" @condition-change="onTableConditionChange" @selection-change="portChangeSelection"
         :show-custom-header="true" :show-search-tool="showSearchTool">
        </el-table-wrapper>
      </div>
      <div>
        <div class="title-bar title-h4">시간 설정</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="차단 시작 시간" prop="startTime">
              <w-time-picker-by-min style="width:100%;" :placeHolderData="startHolder" :timeType="startType" :timeData="controlInfo.startTime" @change="changePicker"></w-time-picker-by-min>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="차단 종료 시간" prop="endTime">
              <w-time-picker-by-min style="width:100%;" :placeHolderData="endHolder" :timeType="endType" :timeData="controlInfo.endTime" @change="changePicker"></w-time-picker-by-min>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button class="mr-r4" size="large" type="solid" @click="savePortControlList">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import moment from 'moment';
import { forEach, isNil, clone } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WTimePickerByMin from '@/views/settings/server/SecuritySettings/component/TimePickerByMin';

export default {
  name: 'WFileChangeSaveGroupPopup',
  components: {
    WTimePickerByMin,
  },
  props: {
    popupType: String,
    editRow: Object,
    selectPhysicalNode: Object,
  },
  data() {
    return {
      columnDefault,
      total: null,
      showSearchTool: false,
      startHolder: '시작 시간',
      startType: 'startTime',
      endHolder: '종료 시간',
      endType: 'endTime',
      selectTitle: '차단 포트 등록',
      checkSvcPortList: [],
      dataList: null,
      serverId: null,
      controlInfo: {
        startTime: null,
        endTime: null,
      },
      fileDetectColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'netPortnum',
          label: '포트번호',
          sortable: true,
          searchable: true,
          remoteProp: 'net_portnum',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'serviceName',
          label: '포트명',
          sortable: true,
          searchable: true,
          remoteProp: 'service_name',
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    editRow: {
      handler(row) {
        this.controlInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.selectTitle = `[${this.selectPhysicalNode.label}] 차단 포트 등록`;
          this.loadData();
        }
      },
      immediate: true,
    },
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode) && this.selectPhysicalNode.type === 'obj') {
          this.serverId = this.selectPhysicalNode.serverId;
        }
      },
    },
  },
  methods: {
    loadData() {
      this.$nextTick(() => {
        if (Object.keys(this.selectPhysicalNode).indexOf('obj') > 0) {
          const tableParams = this.$refs.portControlTable.getParameter();
          const serverParams = {
            serverId: this.serverId,
          };
          const params = Object.assign(tableParams, serverParams);
          ServerSettingAPI.getServicePortList(params).then((response) => {
            if (response.data.success) {
              this.dataList = response.data.data;
              this.total = response.data.total;
            }
          });
        }
      });
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    convertDatetime(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return new Date(value);
    },
    portChangeSelection(selectVal) {
      this.checkSvcPortList = selectVal;
    },
    /**
     * [savePortControlList 포트 접근 차단 항목을 추가 또는 수정하여 저장한다.]
     * @author yelim
     */
    savePortControlList() {
      const convertParam = clone(this.checkSvcPortList);
      const saveParamList = [];
      const target = '차단 포트';
      if (this.controlInfo.startTime < this.controlInfo.endTime) {
        forEach(convertParam, (item) => {
          saveParamList.push({
            serverId: item.serverId,
            portNumber: item.netPortnum,
            startTime: this.controlInfo.startTime,
            endTime: this.controlInfo.endTime,
          });
        });
        ServerSettingAPI.insertPortControl(saveParamList).then((response) => {
          if (response.data.success) {
            if (response.data.data === 'DUPLICATE') {
              this.$message.error('이미 차단된 포트입니다.');
            } else {
              this.$emit('reload-data');
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, target, true));
              this.closePopup();
            }
          }
        });
      } else {
        this.controlInfo.startTime = this.editRow.startTime;
        this.controlInfo.endTime = this.editRow.endTime;
        this.$message.error('시작 시간과 종료 시간을 확인해 주세요.');
      }
    },
    changePicker(value, timeType) {
      const splitData = value.split(':');
      const datetime = moment();
      datetime.year(1970).month(0).date(1);
      datetime.hours(splitData[0]).minutes(splitData[1]).seconds(0).milliseconds(0); // 0시0분0초 설정
      this.controlInfo[timeType] = datetime.toDate().getTime();
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/SecuritySettings/PortAccessControlView/popup/PortControlPopup.vue